(function () {
  if (customElements.get('password-modal')) return;

  class PasswordModal extends window.DetailsModal {
    constructor() {
      super();

      if (this.querySelector('input[aria-invalid="true"]')) this.open({ target: this.querySelector('details') });
    }
  }

  customElements.define('password-modal', PasswordModal);
})();
